module.exports = __webpack_public_path__ + "static/media/breadcrumb01.acbaa18e.png";